import React, { memo, useContext, useEffect, useState } from "react"
import VerticalLayout from "../../VerticalLayout/index"
import { Button, Row, Col } from "reactstrap"
import { useLocation } from "react-router-dom"
import ParamsValues from "../../../constants/ParamsValues"
import { DetailsContext } from "./DetailsContainerContext"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import GenericConstants from "../../../constants/GenericConstants.json"
import "./styles.css"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { Input } from "reactstrap"
import { db, storage } from "../../../helpers/firebase_helper"
import { PencilFill, Trash } from "react-bootstrap-icons"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"

const DetailsContainer = () => {
  const detailsModel = useContext(DetailsContext)
  const [buttonName, setButtonName] = useState("")
  const [currentDetailsPage, setCurrentDetailsPage] = useState("")
  let history = useHistory()
  const {
    orderDetails,
    userDetails,
    serviceDetails,
    adminDetails,
    currentJobParticular,
    currentPartnerType,
    particularList,
    getOrderDetails,
    getServiceDetails,
    getAdminDetails,
    getPartnerTypes,
    getParticulars,
    getUserDetails,
  } = detailsModel
  const [selectedImage, setSelectedImage] = useState(null)

  const location = useLocation()
  const { search } = useLocation()
  //This is the id of the current selected service from the services list
  const serviceId = search.substring(2)
  const pathName = location.pathname
  //Object keeps the partner data
  const [partnerPostData, setParterPostData] = useState({
    name: "",
    additionalFare: 0,
    baseFare: 0,
    currency: "INR",
  })
  const [currentPageDetails, setCurrentPageDetails] = useState("")
  const [selectedType, setSelectedType] = useState("partnerType")
  const [openPartnerModal, setOpenPartnerModal] = useState(false)
  const [openParticularModal, setOpenParticularModal] = useState(false)
  const [particularDisalbed, setParticularDisabled] = useState(false)
  const [showBlockUser, setShowBlockUser] = useState(false)
  const [currentUserOrdersList, setCurrentUserOrdersList] = useState()
  const [createEditSpinner, setCreateEditSpinner] = useState(false)
  const [addParticularModal, setAddParticularModal] = useState(true)

  let rowNumber = 0

  const particularModalToggle = () => {
    setParticularData({
      name: "",
    })
    setOpenParticularModal(!openParticularModal)
  }

  const partnerTypeModalToggle = () => {
    setParterPostData({
      name: "",
      additionalFare: 0,
      baseFare: 0,
      currency: "INR",
    })
    setOpenPartnerModal(!openPartnerModal)
  }

  useEffect(() => {
    switch (pathName) {
      default:
        break
      case ParamsValues.ORDER_DETAILS_PATH:
        getOrderDetails()
        break
      case "/details/adminId":
        getUserDetails(location.search.split("=")[1])
        break
      case "/details/serviceId":
        setCurrentPageDetails(GenericConstants.SERVICE)
        getServiceDetails(location.search.split("=")[1])
        break
      case "/details/userId":
        // setCurrentPageDetails(GenericConstants.SERVICE)
        getUserDetails(location.search.split("=")[1])
        break
      case "/details/providerId":
        getUserDetails(location.search.split("=")[1])
        break

      // text = "Today is Sunday";
    }
  }, [])

  useEffect(() => {
    if (particularList.length > 3) {
      setAddParticularModal(false)
    } else {
      setAddParticularModal(true)
    }
  }, [particularList])

  const userType = () => {
    switch (pathName) {
      default:
        return "User"
      case "/details/adminId":
        return "Admin"
      case "/details/providerId":
        return "Partner"
      case "/details/serviceId":
        return "Service Details"
    }
  }

  //FIREBASE INTEGRATION

  // Object keeps the particular data
  const [particularData, setParticularData] = useState({
    name: "",
  })

  const [selectedId, setSelectedId] = useState(null)
  const [showDeletePartner, setShowDeletePartner] = useState(false)
  const [showDeleteParticular, setDeleteParticular] = useState(false)
  const [proceedPartnerEditModal, setProceedPartnerEditModal] = useState(false)
  const [proceedParticularEditModal, setProceedParticularEditModal] =
    useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const goBackButtonText = "< Back"
  const [contactNumber, setContactNumber] = useState(
    serviceDetails?.supportNumber ? serviceDetails?.supportNumber : ""
  )
  const [tax, setTax] = useState(
    serviceDetails?.tax ? serviceDetails?.tax * 100 : 0
  )
  const [taxSpinner, setTaxSpinner] = useState(false)
  const [contactNumberSpinner, setContactNumberSpinner] = useState(false)

  useEffect(() => {
    setTax(serviceDetails?.tax ? serviceDetails?.tax * 100 : 0)
    setContactNumber(
      serviceDetails?.supportNumber ? serviceDetails?.supportNumber : ""
    )
  }, [serviceDetails])
  /**
   * This function creates new partner type under a selected service
   */
  const submitPartnerType = async () => {
    setCreateEditSpinner(true)
    if (selectedImage) {
      const path = storage.ref(
        "partnerTypes/" + moment().unix() + selectedImage.name
      )

      path.put(selectedImage).then(function () {
        path.getDownloadURL().then(async function (url) {
          await db
            .collection("services")
            .doc(serviceId)
            .collection("partnerTypes")
            .doc()
            .set(
              { ...partnerPostData, image: url },
              {
                merge: true,
              }
            )
          setOpenPartnerModal(false)
          getPartnerTypes(serviceId)
          setShowSuccessModal(true)
          setCreateEditSpinner(false)
        })
      })
    } else {
      await db
        .collection("services")
        .doc(serviceId)
        .collection("partnerTypes")
        .doc()
        .set(partnerPostData, {
          merge: true,
        })
      setOpenPartnerModal(false)
      getPartnerTypes(serviceId)
      setShowSuccessModal(true)
      setCreateEditSpinner(false)
    }
  }

  /**
   * This function deletes partner type under a selected service
   */
  const deletePartnertype = async () => {
    await db
      .collection("services")
      .doc(serviceId)
      .collection("partnerTypes")
      .doc(selectedId)
      .delete()
    getPartnerTypes(serviceId)
    setShowSuccessModal(true)
  }

  /**
   * This function edits the selected partner type under a selected service
   */
  const editPartnerType = async () => {
    await db
      .collection("services")
      .doc(serviceId)
      .collection("partnerTypes")
      .doc(selectedId)
      .set(partnerPostData, {
        merge: true,
      })
    setOpenPartnerModal(false)
    getPartnerTypes(serviceId)
    setShowSuccessModal(true)
  }

  /**
   * This function fills up the modal popup for the selected partner edit
   * @param {object} data
   */
  const keepEditValuesInPartnerStateObject = data => {
    setParterPostData({
      name: data.name,
      additionalFare: parseInt(data.additionalFare),
      baseFare: parseInt(data.baseFare),
      currency: data.currency,
    })
  }

  const keepEditValuesInParticularStateObject = data => {
    setParticularData({
      name: data.name,
      disabled: data.disabled,
    })
  }

  /**
   * This funciton creates new particular under a selected service
   */
  const submitParticular = async () => {
    setOpenParticularModal(false)
    await db
      .collection("services")
      .doc(serviceId)
      .collection("particulars")
      .doc()
      .set(particularData, {
        merge: true,
      })
    setOpenPartnerModal(false)
    getParticulars(serviceId)
    setShowSuccessModal(true)
  }

  /**
   * This function deletes particular type under a selected service
   */
  const deleteParticularType = async () => {
    await db
      .collection("services")
      .doc(serviceId)
      .collection("particulars")
      .doc(selectedId)
      .delete()
    setOpenPartnerModal(false)
    getParticulars(serviceId)
    setShowSuccessModal(true)
  }

  /**
   * This function edits the selected particular under a selected service
   */
  const editParticular = async () => {
    await db
      .collection("services")
      .doc(serviceId)
      .collection("particulars")
      .doc(selectedId)
      .set(particularData, {
        merge: true,
      })
    setOpenPartnerModal(false)
    getParticulars(serviceId)
    setShowSuccessModal(true)
    setProceedPartnerEditModal(false)
  }

  const blockerUser = async () => {
    const blockStatusChange = { disabled: !userDetails?.disabled }
    await db
      .collection("users")
      .doc(location.search.split("=")[1])
      .set(blockStatusChange, {
        merge: true,
      })
    getUserDetails(location.search.split("=")[1])
    setShowSuccessModal(true)
  }

  useEffect(() => {}, [currentPartnerType, particularList])

  const getCurrentUserOrders = async () => {
    const snapshot = await db
      .collection("orders")
      .where("userId", "==", location.search.split("=")[1])
      .get()
    const data = snapshot.docs.map(doc => {
      return { ...doc.data(), id: doc.id }
    })
    setCurrentUserOrdersList(data)
  }

  useEffect(() => {
    getCurrentUserOrders()
  }, [])

  const updateContactNumber = async () => {
    setContactNumberSpinner(true)
    await db
      .collection("services")
      .doc(serviceId)
      .update({ supportNumber: contactNumber })
    setContactNumberSpinner(false)
  }

  const updateTax = async () => {
    setTaxSpinner(true)
    await db
      .collection("services")
      .doc(serviceId)
      .update({ tax: tax / 100 })
    setTaxSpinner(false)
  }

  const resetPartnerTypeFormValues = () => {
    setParterPostData({
      name: "",
      additionalFare: 0,
      baseFare: 0,
      currency: "INR",
    })
  }

  const resteParticularFormValues = () => {
    setParticularData({
      name: "",
    })
  }

  return (
    <VerticalLayout>
      {currentPageDetails === GenericConstants.SERVICE && (
        <div style={{ marginTop: "70px" }} className="p-4">
          {" "}
          <Button
            className="bg-dark text-white mb-5"
            onClick={() => history.goBack()}
          >
            {goBackButtonText}
          </Button>
          <div>{userType()}</div>
          <Row className="align-items-center p-3">
            <Col>
              <h6 className="m-0 font-size-16 ">
                {" "}
                <h4>Name: {serviceDetails?.name}</h4>
              </h6>
              <div></div>
            </Col>
            <Col>
              <h6 className="m-0 font-size-16 ">
                {" "}
                <h4>
                  Status: {serviceDetails?.disabled ? "Disabled" : "Enabled"}
                </h4>
              </h6>
            </Col>
          </Row>
          <div>
            <span>Tax:</span>
            <input
              value={tax}
              style={{
                maxWidth: "40px",
                marginLeft: "5px",
                paddingLeft: "2px",
              }}
              onChange={e => setTax(e.target.value)}
            />
            %
            <button
              style={{
                background: "black",
                color: "white",
                border: "black solid 1px",
                cursor: "pointer",
                borderRadius: "2px",
                marginLeft: "4px",
                width: "60px",
              }}
              onClick={updateTax}
            >
              {taxSpinner ? (
                <div
                  class="spinner-border text-light"
                  role="status"
                  style={{ width: "18px", height: "18px" }}
                ></div>
              ) : (
                "Update"
              )}
            </button>
          </div>
          <div className="pt-2">
            Contact number:{" "}
            <span>
              <input
                value={contactNumber}
                style={{ paddingLeft: "8px" }}
                onChange={e => setContactNumber(e.target.value)}
              />

              <button
                onClick={updateContactNumber}
                style={{
                  background: "black",
                  color: "white",
                  border: "black solid 1px",
                  cursor: "pointer",
                  borderRadius: "2px",
                  marginLeft: "4px",
                  width: "60px",
                }}
              >
                {" "}
                {contactNumberSpinner ? (
                  <div
                    class="spinner-border text-light"
                    role="status"
                    style={{ width: "18px", height: "18px" }}
                  ></div>
                ) : (
                  "Update"
                )}
              </button>
            </span>
          </div>
          <Row className="align-items-center p-3">
            <Col className="d-flex">
              <Button
                className={`${
                  selectedType === "partnerType"
                    ? "bg-success text-white"
                    : "bg-white text-black"
                }`}
                onClick={() => setSelectedType("partnerType")}
              >
                Partner type
              </Button>
              <Button
                onClick={() => setSelectedType("particular")}
                style={{ marginRight: "auto" }}
                className={`${
                  selectedType === "particular"
                    ? "bg-success text-white"
                    : "bg-white text-black"
                }`}
              >
                Particualrs
              </Button>
              <Button
                variant="danger"
                className="red-btn"
                onClick={() => {
                  setProceedPartnerEditModal(false)
                  resetPartnerTypeFormValues()
                  setOpenPartnerModal(true)
                }}
              >
                + Partner type
              </Button>{" "}
              <Button
                variant="danger"
                className="red-btn"
                onClick={() => {
                  setProceedParticularEditModal(false)
                  resteParticularFormValues()
                  setOpenParticularModal(true)
                }}
                disabled={!addParticularModal}
              >
                + Particular
              </Button>{" "}
              {/* {ADD PARTICULAR MODAL} */}
              <Modal
                isOpen={openParticularModal}
                backdrop={true}
                toggle={particularModalToggle}
              >
                <ModalHeader toggle={particularModalToggle}>
                  Particular type
                </ModalHeader>
                <ModalBody>
                  Name:{" "}
                  <Input
                    onChange={e => {
                      setParticularData({
                        ...particularData,
                        name: e.target.value,
                      })
                    }}
                    value={particularData.name}
                  />
                  <div className="pt-2">
                    <span className="margin-right-1">Disabled :</span>
                    <Input
                      className="pt-2"
                      type="checkbox"
                      onChange={e =>
                        setParticularData({
                          ...particularData,
                          disabled: e.target.checked,
                        })
                      }
                      checked={particularData.disabled}
                    />
                  </div>
                </ModalBody>
                <div className="m-auto mb-3">
                  <Button
                    variant="dark"
                    className="bg-dark text-white m-auto"
                    onClick={() => {
                      setProceedParticularEditModal(false)
                      particularModalToggle()
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="bg-success text-white m-auto"
                    onClick={() => {
                      proceedParticularEditModal
                        ? editParticular()
                        : submitParticular()
                    }}
                  >
                    {proceedParticularEditModal ? "Update" : "Create"}
                  </Button>
                </div>
              </Modal>
              {/* {ADD PARTNER MODAL} */}
              <Modal
                isOpen={openPartnerModal}
                backdrop={true}
                toggle={partnerTypeModalToggle}
              >
                <ModalHeader>Partner type</ModalHeader>
                <ModalBody>
                  <div className="pb-3">
                    Name:{" "}
                    <Input
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          name: e.target.value,
                        })
                      }}
                    />
                  </div>
                  <div className="pb-3">
                    Base Fare:{" "}
                    <Input
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          baseFare: parseInt(e.target.value),
                        })
                      }}
                    />
                  </div>
                  <div className="pb-3">
                    Additional Fare:{" "}
                    <Input
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          additionalFare: parseInt(e.target.value),
                        })
                      }}
                    />
                  </div>

                  <div className="pb-3">
                    Currency:{" "}
                    <Input
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          currency: e.target.value,
                        })
                      }}
                    />
                  </div>
                </ModalBody>
                <div className="m-auto mb-3">
                  <Button
                    variant="dark"
                    className="bg-dark text-white m-auto"
                    onClick={() => {
                      setProceedPartnerEditModal(false)
                      partnerTypeModalToggle()
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="bg-success text-white m-auto"
                    onClick={() => submitPartnerType()}
                  >
                    {proceedPartnerEditModal ? "Update" : "Create"}
                  </Button>
                </div>
              </Modal>
              {/* {ADD PARTNER MODAL} */}
              <Modal
                isOpen={openPartnerModal}
                backdrop={true}
                toggle={partnerTypeModalToggle}
                allowOutsideClick={true}
              >
                <ModalHeader>Partner type</ModalHeader>
                <ModalBody>
                  <div className="pb-3">
                    Name:{" "}
                    <Input
                      value={partnerPostData.name}
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          name: e.target.value,
                        })
                      }}
                    />
                  </div>
                  <div className="pb-3">
                    Base Fare:{" "}
                    <Input
                      value={partnerPostData.baseFare}
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          baseFare:
                            e.target.value === "Na" ||
                            e.target.value === null ||
                            e.target.value === "" ||
                            e.target.value === 0
                              ? 0
                              : parseInt(e.target.value),
                        })
                      }}
                    />
                  </div>
                  <div className="pb-3">
                    Additional Fare:{" "}
                    <Input
                      value={partnerPostData.additionalFare}
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          additionalFare:
                            e.target.value === "Na" ||
                            e.target.value === null ||
                            e.target.value === "" ||
                            e.target.value === 0
                              ? 0
                              : parseInt(e.target.value),
                        })
                      }}
                    />
                  </div>

                  <div className="pb-3">
                    Icon:{" "}
                    <input
                      type="file"
                      class="form-control"
                      id="customFile"
                      data-kt-image-input="true"
                      accept="image/png, image/jpeg, image/svg"
                      onChange={e => setSelectedImage(e.target.files[0])}
                    />
                  </div>
                  <div className="pb-3">
                    Currency:{" "}
                    <Input
                      value={partnerPostData.currency}
                      onChange={e => {
                        setParterPostData({
                          ...partnerPostData,
                          currency: e.target.value,
                        })
                      }}
                    />
                  </div>
                </ModalBody>
                <div className="m-auto mb-3">
                  <Button
                    variant="dark"
                    className="bg-dark text-white m-auto"
                    onClick={() => {
                      setProceedPartnerEditModal(false)
                      partnerTypeModalToggle()
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="bg-success text-white m-auto"
                    style={{ width: "70px" }}
                    onClick={() =>
                      proceedPartnerEditModal
                        ? editPartnerType()
                        : submitPartnerType()
                    }
                  >
                    {!createEditSpinner
                      ? proceedPartnerEditModal
                        ? "Update"
                        : "Create"
                      : ""}
                    {createEditSpinner && (
                      <div
                        class="spinner-border text-light"
                        role="status"
                        style={{ width: "18px", height: "18px" }}
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    )}
                  </Button>
                </div>
              </Modal>
            </Col>
          </Row>
          {/**
           * PARTNER TYPE LISTED TABLE
           */}
          {currentPartnerType.length > 0 && selectedType === "partnerType" ? (
            <Row>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name :</th>
                    <th scope="col">Base fare :</th>
                    <th scope="col">Currency :</th>
                    <th scope="col">Additional fare :</th>
                    <th scope="col">Actions :</th>
                  </tr>
                </thead>

                <tbody>
                  {/* <tr
                  // onClick={() => {
                  //   try {
                  //     history.push(
                  //       `/job/orderId?=${orderDetails?.data?.job?.id}`
                  //     )
                  //   } catch (e) {}
                  // }}
                  >
                    {} */}
                  {currentPartnerType &&
                    currentPartnerType?.map(_item => {
                      return (
                        <tr>
                          <td scope="row">{_item?.name}</td>
                          <td scope="row">{_item?.baseFare}</td>
                          <td scope="row">{_item?.currency}</td>
                          <td scope="row">{_item?.additionalFare}</td>
                          <td scope="row">
                            <PencilFill
                              onClick={() => {
                                setSelectedId(_item.id)
                                setProceedPartnerEditModal(true)
                                keepEditValuesInPartnerStateObject(_item)
                                setOpenPartnerModal(true)
                              }}
                              className="cursor-pointer action-icon-size"
                            />
                            <Trash
                              value={_item?.id}
                              onClick={e => {
                                setSelectedId(_item.id)
                                setShowDeletePartner(true)
                              }}
                              className="cursor-pointer action-icon-size"
                            />
                          </td>
                        </tr>
                      )
                    })}
                  {/* </tr> */}
                </tbody>
              </table>
            </Row>
          ) : selectedType === "partnerType" ? (
            <div className="m-auto text-center">No Data</div>
          ) : (
            ""
          )}
          {/**
           * PARTICULARS LISTED TABLE
           */}
          {particularList.length > 0 && selectedType === "particular" ? (
            <Row>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name :</th>
                    <th scope="col">Status :</th>
                    <th scope="col">Actions :</th>
                  </tr>
                </thead>

                <tbody>
                  {particularList &&
                    particularList?.map(_item => {
                      return (
                        <tr>
                          <td scope="row">{_item?.name}</td>
                          <td scope="row">
                            {_item?.disabled ? "Disabled" : "Enabled"}
                          </td>
                          <td scope="row">
                            <PencilFill
                              onClick={() => {
                                setSelectedId(_item.id)
                                setProceedParticularEditModal(true)
                                keepEditValuesInParticularStateObject(_item)
                                setOpenParticularModal(true)
                              }}
                              className="cursor-pointer action-icon-size"
                            />
                            <Trash
                              value={_item?.id}
                              onClick={e => {
                                setSelectedId(_item.id)
                                setDeleteParticular(true)
                              }}
                              className="cursor-pointer action-icon-size"
                            />
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </Row>
          ) : selectedType === "particular" ? (
            <div className="m-auto text-center">No Data</div>
          ) : (
            ""
          )}
        </div>
      )}
      {currentPageDetails !== GenericConstants.SERVICE && (
        <div style={{ marginTop: "70px" }} className="p-4">
          <Button
            className="bg-dark text-white mt-5 mb-5"
            onClick={() => history.goBack()}
          >
            {goBackButtonText}
          </Button>
          <Row className="align-items-center p-3">
            <Col>
              <h6 className="m-0 font-size-16 ">
                {" "}
                {/* <h2>{orderDetails?.data?.name}</h2> */}
                <h3>{userType()}</h3>
              </h6>
              <div></div>
            </Col>
            <Col>
              <Button
                color={`${userDetails?.disabled ? "success" : "danger"}`}
                className={`btn ${
                  userDetails?.disabled ? "btn-success" : "btn-danger"
                } waves-effect waves-light`}
                onClick={() => setShowBlockUser(true)}
              >
                {`${userDetails?.disabled ? "Unblock" : "Block"} ${userType()}`}
              </Button>{" "}
            </Col>
          </Row>
          <Row className="align-items-center p-3">
            <Row className="mb-4">
              <h5>Name : {userDetails.name}</h5>
              <div></div>
            </Row>
            <Col>
              <h5>Phone : {userDetails.phone}</h5>
              <div></div>
            </Col>
            <Col>
              <h5>Email : {userDetails.email}</h5>
              <div></div>
            </Col>
          </Row>
          <Row className="align-items-center p-3">
            <Col>
              <h5>Addresses :</h5>
              {userDetails?.userAddresses?.map((item, index) => {
                return (
                  <div className="pt-2">
                    Address: {index + 1}
                    <div>
                      <strong>Name: </strong> {item.name}
                    </div>
                    <div>
                      {" "}
                      <strong>Latitdue: </strong> {item.latitude}
                    </div>
                    <div>
                      <strong> Longitude: </strong> {item.longitude}
                    </div>
                    <div>
                      <strong> Address: </strong> {item.address}
                    </div>
                    <div>
                      <strong>Pin code:</strong> {item.pincode}
                    </div>
                  </div>
                )
              })}
              <div></div>
            </Col>
          </Row>
          {userType() !== "Admin" && (
            <Row className="align-items-center p-3">
              <Col>
                <h5>User orders :</h5>
              </Col>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Oder Id :</th>
                    <th scope="col">Job :</th>
                    <th scope="col">Date :</th>
                    <th scope="col">Status :</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUserOrdersList?.length > 0 &&
                    currentUserOrdersList?.map(item => {
                      return (
                        <>
                          {
                            <tr
                              id={item.id}
                              key={`order-${item.id}`}
                              onClick={() => {
                                history.push(`/job/orderId?=${item.id}`)
                              }}
                            >
                              <th scope="row">{rowNumber++}</th>
                              <td>{item?.addressId}</td>
                              <td>{item?.scheduled ? "True" : "False"}</td>
                              <td>{item?.serviceId}</td>
                              <td>
                                {moment(item?.from?.seconds)
                                  .utcOffset("+05:30")
                                  .format("h:mm:ss a, DD/MM/YYYY")}
                              </td>
                              <td>
                                {moment(item?.to?.seconds).format(
                                  "h:mm:ss a, DD/MM/YYYY"
                                )}
                              </td>
                              <td>{item?.comment}</td>
                            </tr>
                          }
                        </>
                      )
                    })}
                </tbody>
                {/* <tbody>
                <tr
                  onClick={() => {
                    try {
                      history.push(
                        `/job/orderId?=${orderDetails?.data?.job?.id}`
                      )
                    } catch (e) {}
                  }}
                >
                  {orderDetails &&
                    orderDetails?.data?.job?.map(job => {
                      return (
                        <>
                          <td scope="row">{job?.id}</td>
                          <td>{job?.name}</td>
                          <td></td>
                          <td></td>
                        </>
                      )
                    })}
                </tr>
              </tbody> */}
              </table>
            </Row>
          )}
        </div>
      )}
      {/* {ALERT FOR DELETE PARTNER} */}
      <SweetAlert
        warning
        // show={showDeletePartnerAlert}
        showCancel
        show={showDeletePartner}
        confirmBtnText="Confirm"
        confirmBtnBsStyle={"danger"}
        title={"Are you sure want to delete ?"}
        onConfirm={() => {
          deletePartnertype(selectedId)
          setShowDeletePartner(false)
        }}
        onCancel={() => {
          setShowDeletePartner(false)
          proceedPartnerEditModal(false)
        }}
        focusCancelBtn
      ></SweetAlert>
      {/* {ALERT FOR DELETE PARTICULAR} */}
      <SweetAlert
        warning
        showCancel
        show={showDeleteParticular}
        cancelButtonText="Cancel"
        confirmBtnText="Confirm"
        confirmBtnBsStyle={"danger"}
        title={"Are you sure want to delete ?"}
        onConfirm={() => {
          deleteParticularType(selectedId)
          setDeleteParticular(false)
        }}
        onCancel={() => {
          setDeleteParticular(false)
        }}
        focusCancelBtn
      ></SweetAlert>
      {/*SUCCESS ALERT FOR COMMON */}
      <SweetAlert
        success
        show={showSuccessModal}
        confirmBtnText="Ok"
        confirmBtnBsStyle={"success"}
        title={"Success"}
        onConfirm={() => {
          setShowSuccessModal(false)
          setShowDeletePartner(false)
          setOpenPartnerModal(false)
          setOpenParticularModal(false)
        }}
      ></SweetAlert>
      {/* {ALERT FOR BLOCK USER} */}
      <SweetAlert
        warning
        // show={showDeletePartnerAlert}
        showCancel
        show={showBlockUser}
        confirmBtnText="Confirm"
        confirmBtnBsStyle={"danger"}
        title={"Are you sure want to block this user ?"}
        onConfirm={() => {
          blockerUser(selectedId)
          setShowBlockUser(false)
        }}
        onCancel={() => {
          setShowBlockUser(false)
        }}
        focusCancelBtn
      ></SweetAlert>
    </VerticalLayout>
  )
}

export default DetailsContainer
